<h2 mat-dialog-title class="mfa-dialog-title">
  <mat-icon class="mfa-alarm-icon">alarm</mat-icon>
  <span>{{ 'MFA.Reminder.Title' | translate: locale.language }}</span>
</h2>

<mat-dialog-content class="mfa-reminder-content">
  <p class="mfa-body" [innerHTML]=" 'MFA.Reminder.Body' | translate: locale.language "></p>

  <div class="mfa-setup-card">
    <mat-icon class="mfa-setup-icon">shield</mat-icon>
    <span class="mfa-setup-desc" [innerHTML]="'MFA.Reminder.SetupDesc' | translate: locale.language "></span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="remindLater()" color="primary">{{ 'MFA.Reminder.RemindLater' | translate: locale.language }}</button>
  <button mat-raised-button color="primary" (click)="setupNow()">{{ 'MFA.Reminder.SetupNow' | translate: locale.language }}</button>
</mat-dialog-actions>
